import {Injectable} from '@angular/core';
import {cloneDeep} from 'lodash-es';
import {Observable, of} from 'rxjs';
import {WidgetSettingsService} from '../../../components/layout/widget/widget-settings-service';
import {
    getDefaultColumnsConfigByDef,
    normalizeColumnsConfig,
    TableColumnsSizingMode
} from '../../../components/tables/table';
import {correctEnum} from '../../components/common-widget.implementation';
import {DEX_TX_HISTORY_TABLE_COLUMNS_DEF, DexTxHistoryTableColumnConfig} from '../dex-tx-history-table';
import {
    DexTxHistoryWidgetSettings,
    DexTxHistoryWidgetSettingsDef,
    DexTxHistoryWidgetTab
} from './dex-tx-history-widget-settings';

@Injectable()
export class DexTxHistoryWidgetSettingsService implements WidgetSettingsService {

    private readonly defaultColumnsSizingMode: TableColumnsSizingMode = TableColumnsSizingMode.AUTO;

    private readonly defaultColumnsSettings: DexTxHistoryTableColumnConfig[] =
                         getDefaultColumnsConfigByDef(DEX_TX_HISTORY_TABLE_COLUMNS_DEF);

    private readonly defaultTab = DexTxHistoryWidgetTab.RECENT;

    public getDefaultSettings(): Observable<DexTxHistoryWidgetSettings> {
        return of({
            title:               null,
            tab:                 this.defaultTab,
            filters:             {},
            columns:             this.defaultColumnsSettings.slice(),
            columnsResizingMode: TableColumnsSizingMode.AUTO
        } satisfies DexTxHistoryWidgetSettings);
    }

    public fromDefinition(
        settingsDef: DexTxHistoryWidgetSettingsDef
    ): Observable<DexTxHistoryWidgetSettings> {
        return of({
            title:   settingsDef.title,
            columns: settingsDef.columns
                         ? normalizeColumnsConfig(DEX_TX_HISTORY_TABLE_COLUMNS_DEF, settingsDef.columns)
                         : this.defaultColumnsSettings.slice(),

            columnsResizingMode: settingsDef
                                     && TableColumnsSizingMode[settingsDef.columnsResizingMode]
                                     || this.defaultColumnsSizingMode,

            tab:     correctEnum(DexTxHistoryWidgetTab, settingsDef.tab, this.defaultTab),
            filters: {
                ...(settingsDef.filters || undefined)
            }
        } satisfies DexTxHistoryWidgetSettings);
    }

    public toDefinition(
        settings: DexTxHistoryWidgetSettings
    ): DexTxHistoryWidgetSettingsDef {
        return {
            title:               settings.title,
            columns:             settings.columns && settings.columns.slice(),
            columnsResizingMode: settings.columnsResizingMode,
            tab:                 settings.tab,
            filters:             settings.filters && cloneDeep(settings.filters)
        } satisfies DexTxHistoryWidgetSettingsDef;
    }

}
